import React from 'react';

import { COLUMNS_COUNT_OPTIONS, COLUMNS_GAP_OPTIONS } from '@wp-block-builder/blocks/ColumnsSection/parsers';
import { generateRandomBlockId } from '@wp-block-builder/package';

import { type TColumnsSectionBlock } from '../../../../../blocks/ColumnsSection';
import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import AddContainerButton from './Container';
import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TColumnsSectionBlock => ({
  id: generateRandomBlockId(),
  type: 'ColumnsSection',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'normal',
    textAlign: 'left',
    ...style,
  },
  props: {
    dimensionsRule: 'percentage',
    columnGridDimensions: [4, 8],
    contentAlignment: 'middle',
    columnsCount: COLUMNS_COUNT_OPTIONS.defaultValue,
    columnGap: COLUMNS_GAP_OPTIONS.defaultValue,
    mobileLayout: 'columns',
    blocks: [
      AddContainerButton.defaultColumnBlock(),
      AddContainerButton.defaultColumnBlock(),
      AddContainerButton.defaultColumnBlock(),
    ],
  },
  sectionProps: {},
});

export default defineBlockButton<TColumnsSectionBlock>({
  label: 'Columns',
  icon: <BlockTypeIcon type="ColumnsSection" />,
  defaultBlock: () => getDefaultProps({ padding: '16px 24px 16px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
